import React from "react";
import Spinner from "./Spinner";

const LoadingPage = ({ hideText }) => {
  return (
    <div className="h-full w-full flex items-center justify-center bg-white/30 backdrop-blur-md p-6">
      <div className="flex flex-col items-center justify-center gap-4">
        {!hideText && (
          <h2 className=" flex  font-poppins text-light-gray m-0 text-lg text-center">
            Cargando...
          </h2>
        )}
        <Spinner />
      </div>
    </div>
  );
};

export default LoadingPage;
